define(function (require) {

    //==================================================================================
    //=======================================[ Imports ]================================
    //==================================================================================

    let $ = require("jquery");
    require("amcharts.serial");
    require("amcharts.xy");
    require("amcharts.fr");
    require("datatables.net");
    require("datatables.bootstrap");
    require("ajax-promise");
    require("bootstrap");
    let i18n = require("i18n");
    require("lodash");
    require("error-handler");
    require("loadingoverlay");
    require("moment");
    let renders = require("datatables.render.methods");

    //=================================================================================
    //=======================================[ Global ]================================
    //=================================================================================

	let api = {};
	let sreeenSize = {
		md: 768,//px
		lg: 1200,//px
	};

	parseStringToHtml();

	//Pour que DataTables.net throw les erreurs dans la console au lieu d'un alert()
	$.fn.dataTable.ext.errMode = 'throw';


    //====================================================================================
    //=======================================[ Initialize ]===============================
    //====================================================================================

	$(function () {
        api = {
            columnDefs: {
                topFonds: [{ targets: 4, className:"font-size-small"}]
			},
			columns: getColumn(),
            searchUrl: "",
            defaultDisplayCount: 10,
            $tableResult: {
                topFonds: $("#tab-top-fund")
            }
        };

        // Pour chaque colonne on ajoute une property "data" égale au nom (correspond au field de la datasource)
        for (let column of api.columns) {
			column.data = column.name;
        }

        // initialize
        init();
        
        // chart fonds du jour
        $(function () {
            if ($("#focus-fund-source").val()) {
                
                let amChartConfigHisto = JSON.parse($("#focus-fund-source").val());
                if (amChartConfigHisto) {
                    $("#fonds-jour-legend-chart").empty();
                    AmCharts.makeChart("tdbFocusFonds", amChartConfigHisto);
                }
                else {
                    $("#tdbFocusFonds [data-error]").removeClass("hidden");
                }
            }
        });
    });
    

    //====================================================================================
    //=========================================[ Events ]=================================
    //====================================================================================


    //====================================================================================
    //=======================================[ Functions ]================================
    //====================================================================================

	function getColumn() {
		let col = [];
		col.push({ name: "sUrl", visible: false });
		col.push({ name: "ID_Produit", visible: false });
		col.push({ name: "nRank", visible: false });
		col.push({ name: "sNom", title: i18n.nom, render: renderNom });
		col.push({ name: "sNomCat", title: i18n.nomcat });
		col.push({ name: "nAmount", title: i18n.vl, className: "text-right", render: renderAmount });
		if (screen.width >= sreeenSize.md) {
			col.push({ name: "sCurrency", title: i18n.dev });
			col.push({ name: "nStarRating", title: i18n.notation, render: renders.renderNotation });
			col.push({ name: "nRetYtd", title: i18n.ytd, render: renderAmountPourc });
			col.push({ name: "nRet1A", title: i18n.nRet1a, render: renderAmountPourc });
			col.push({ name: "nRet3A", title: i18n.nRet3a, render: renderAmountPourc });
			col.push({ name: "dtCalcul", title: i18n.date, render: renders.RenderDate });
		}
		else {
			col.push({ name: "sCurrency", visible: false });
			col.push({ name: "nStarRating", visible: false });
			col.push({ name: "nRetYtd", visible: false });
			col.push({ name: "nRet1A", visible: false });
			col.push({ name: "nRet3A", visible: false });
			col.push({ name: "dtCalcul", visible: false });

		}
		col.push({ name: "nScore", visible: false });
		return col;
	}

    function initFondsTopTable(cTypeInit) {
        api.topFondsOptions = {
            $table: api.$tableResult.topFonds,
            columns: api.columns,
            destroy: true,
            url: api.searchUrl,
            columnDefs: api.columnDefs.topFonds,
            backColors: [],
            orderbyColumnNum: [[2, 'asc']], //-- order by value
            defaultDisplayCount: api.defaultDisplayCount,
            params: {},
			evolutionIconUrl: ""
		};
        if ($("#top-fund-source").length > 0) {
            api.TopFondsDataTableApi = getTable(api.topFondsOptions);
        }
        
    }

    function getTable(option) {
        return option.$table.DataTable({
            destroy: option.destroy,
            columnDefs: option.columnDefs,
            autoWidth: false,
            lengthMenu: [5, 10, 25, 50, 100],
            pageLength: option.defaultDisplayCount,
            bLengthChange: false,
            searching: false,
            ordering: true,
            bInfo: false,
            order: option.orderbyColumnNum,
            pagingType: "numbers",
            dom: "<f><tr><'dataTableFooter'pil><'clearfix'>",
            columns: option.columns,
            language: {},
            ajax: function (data, callback, settings) {

                let dataLoad = $("#top-fund-source").val();                
                callback(JSON.parse(dataLoad));            

            },
            preDrawCallback: function () {
                option.$table.parent().LoadingOverlay("show");
            },
            drawCallback: function () {
                option.$table.parent().LoadingOverlay("hide", true);
            },
            initComplete: option.initCompliteFunc
        });
    }

    function initChart() {
        let idStartBy = "chartEncours";
        createChart(3, idStartBy);
        createChart(5, idStartBy);
        createChart(8, idStartBy);

        idStartBy = "chartFDJ";
        createChart(1, idStartBy);
        createChart(3, idStartBy);
        createChart(5, idStartBy);
    }

    function createChart(year, idStartBy) {
        let $inputChartConfigEncours = $("#" + idStartBy + year + "a [data-chartconfig]");
        if ($inputChartConfigEncours.length > 0) {
            let jsonConfig = $inputChartConfigEncours.val();
            if (jsonConfig !== null && jsonConfig !== "") {
                let amChartConfigEncours = JSON.parse(jsonConfig);

                $inputChartConfigEncours.remove();
                AmCharts.makeChart(idStartBy + year + "a", amChartConfigEncours);

                JSON.parse(jsonConfig);
            }
            else {
                $("#" + idStartBy + year + "a [data-error]").removeClass("hidden");
            }
        }
    }

    function init() {
        initFondsTopTable();
        initChart();
        parseStringToHtml();
    }

    //==================================================================================
    //=====================================[ Utilities ]================================
    //==================================================================================
       
    function parseStringToHtml() {
		$(".stringToHtml").each(function (i, el) {
			let targetContainer = $(this);
			let html = $.parseHTML(targetContainer.text(), true);
			$(targetContainer).html(html);
		});
    }


    //==================================================================================
    //=======================================[ Renders ]================================
    //==================================================================================


    function renderNom(data, type, row, meta) {

        if (!row.sNom) row.sNom = "";

        let result = row.sNom;

        if (row.sUrl) {
            let client_preferenceOpenFicheFonds = 1;
            let $pref = $("#popupFicheFonds");
            if ($pref.val().length > 0) {
                client_preferenceOpenFicheFonds = parseInt($pref.val());
            }
            let target_blank = client_preferenceOpenFicheFonds === 1 ? " target='_blank'" : "";
            result = "<a href='" + row.sUrl + "' " + target_blank + ">" + row.sNom + "</a>";
        }
        return result;
    }

    function renderAmount(data, type, row, meta) {
        if (!data || isNaN(data) || parseFloat(data) === 0) return "-";

        if (parseFloat(data) > 0) {
            return "<span class='text-center label_positive'>" + data.toFixed(2) + "</span>";
        }
        else if (parseFloat(data) < 0) {
            return "<span class='text-center label_negative'>" + data.toFixed(2) + "</span>";
        }

        return data;
    }

    function renderAmountPourc(data, type, row, meta) {
        if (!data || isNaN(data) || parseFloat(data) === 0) return "-";

        return "<span class='text-center'>" + data.toFixed(2) + " %" + "</span>";
    }
});
